



import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CREATE_INVIOCE, CREATE_SUB_INVIOCE, DELETE_INVIOCE, DELETE_SUB_INVIOCE, GET_ALL_INVIOCE, GET_INVIOCE_SUB_CATEGORY, UPDATE_INVIOCE, UPDATE_SUB_INVIOCE, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetInvioce = createAsyncThunk('getINvioce', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_ALL_INVIOCE, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetInvioceSlice = createSlice({
    name: 'Invioce',
    initialState: {
        Invioce: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetInvioce.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetInvioce.fulfilled, (state, action) => {
                state.Invioce = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetInvioce.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});

export const CreateInvioce = createAsyncThunk('CreateInvioce', async (body, { rejectWithValue }) => {
    try {
        const response = await FetchData(CREATE_INVIOCE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateInvioce = createAsyncThunk('UpdateInvioce', async (body, { rejectWithValue }) => {
    try {
        const response = await FetchData(UPDATE_INVIOCE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteInvioce = createAsyncThunk('deleteInvioce', async (id, { rejectWithValue }) => {
    try {
        const response = await FetchData(DELETE_INVIOCE, { invoiceCategoryID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});


// -- Async Thunk to Get User Profile --
export const GetSubInvioce = createAsyncThunk('getSubINvioce', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_INVIOCE_SUB_CATEGORY, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetInvioceSubSlice = createSlice({
    name: 'Invioce',
    initialState: {
        Invioce: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetSubInvioce.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSubInvioce.fulfilled, (state, action) => {
                state.Invioce = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetSubInvioce.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const GetInvioceDetail = createSlice({
    name: 'Invioce Details ',
    initialState: {
        InvioceDetail: ''
    },
    reducers: {
        setInvioceDetials: (state, action) => {
            state.InvioceDetail = action.payload;
        }
    }
});

export const CreateSubInvioce = createAsyncThunk('CreateSubInvioce', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_SUB_INVIOCE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateSubInvioce = createAsyncThunk('updateSubInvioce', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_SUB_INVIOCE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            if (response?.data?.apiStatus?.statusCode === '200') {
                Toast('success', response?.data?.apiStatus?.statusMessage)
                return { status: 200 }
            } else {
                Toast('error', response?.data?.apiStatus?.statusMessage)
                return { status: response?.data?.apiStatus?.statusMessage }
            }


        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteSubInvioce = createAsyncThunk('deleteSubInvioce', async (id, { rejectWithValue }) => {
    try {
        const response = await FetchData(DELETE_SUB_INVIOCE, { invoiceSubCategoryID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const { setInvioceDetials } = GetInvioceDetail.actions
export {
    GetInvioceSlice,
    GetInvioceSubSlice,
    GetInvioceDetail
    // GetProductDetialsSlice
};
